var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CreditPaymentAgreement',{attrs:{"initial-contract-list":_vm.contractList,"product-list":_vm.productList,"from":_vm.from}})}
var staticRenderFns = []

export { render, staticRenderFns }